import { all, takeLatest, put, call } from 'redux-saga/effects';
import renderNotification from '../../helpers/notifications/renderNotification';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';

import { onGetHousingStocks, onCreateHousingStock, onUpdateHousingStock, onDeleteHousingStock } from './api';

import {
  getHousingStocks,
  getHousingStocksSucceeded,
  getHousingStocksFailed,
  createHousingStock,
  createHousingStockSucceeded,
  createHousingStockFailed,
  updateHousingStock,
  updateHousingStockSucceeded,
  updateHousingStockFailed,
  deleteHousingStock,
  deleteHousingStockSucceeded,
  deleteHousingStockFailed
} from './slice';

const { housing_stock_create_success, housing_stock_delete_success } = NOTIFICATION_MESSAGES;

export function* getHousingStocksWorker() {
  try {
    const response = yield call(onGetHousingStocks);
    yield put(getHousingStocksSucceeded(response.data));
  } catch {
    yield put(getHousingStocksFailed());
  }
}

export function* createHousingStockWorker({ payload }) {
  const { housingStock, callback, showSuccessNotification = true } = payload;

  try {
    yield call(onCreateHousingStock, housingStock);

    yield put(createHousingStockSucceeded());
    yield put(getHousingStocks());

    callback?.();
    if (showSuccessNotification) {
      renderNotification({ type: 'success', message: housing_stock_create_success });
    }
  } catch {
    yield put(createHousingStockFailed());
  }
}

export function* updateHousingStockWorker({ payload }) {
  const { housingStock, callback } = payload;

  try {
    yield call(onUpdateHousingStock, housingStock.id, housingStock);

    yield put(updateHousingStockSucceeded());
    yield put(getHousingStocks());

    callback?.();
  } catch {
    yield put(updateHousingStockFailed());
  }
}

export function* deleteHousingStockWorker({ payload }) {
  const { housingStockId, callback } = payload;

  try {
    yield call(onDeleteHousingStock, housingStockId);

    yield put(deleteHousingStockSucceeded());
    yield put(getHousingStocks());

    callback?.();
    renderNotification({ type: 'success', message: housing_stock_delete_success });
  } catch {
    yield put(deleteHousingStockFailed());
  }
}

export default function* housingStocksSaga() {
  yield all([
    takeLatest(getHousingStocks.type, getHousingStocksWorker),
    takeLatest(createHousingStock.type, createHousingStockWorker),
    takeLatest(updateHousingStock.type, updateHousingStockWorker),
    takeLatest(deleteHousingStock.type, deleteHousingStockWorker)
  ]);
}
